<div class="trip-detail-popup-right">
  <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="close()" />
</div>

<div class="notification-dialog-body">
  <div class="accordion-class">
    <h5>{{ isEditMode ? 'Edit Promotional Notification' : 'Create Promotional Notification' }}</h5>
    <mat-divider></mat-divider>
  </div>

  <div class="input-fileds-container category-edit mt-4">
    <div class="group driver-truck" [formGroup]="notificationForm">

      <div class="row mtb">
        <div class="col-md-6">
          <div class="field-label">Trigger Type<span class="required-asterisk">*</span></div>
          <mat-form-field>
            <mat-select formControlName="triggerType" placeholder="Select Trigger Type">
              <mat-option *ngFor="let type of triggerTypes" [value]="type">{{ type }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <div class="field-label">Notification Title<span class="required-asterisk">*</span></div>
          <mat-form-field>
            <input matInput formControlName="title" placeholder='e.g., "Special Offer 🚛"' />
          </mat-form-field>
        </div>
      </div>

      <div class="row mtb">
        <div class="col-md-12">
          <div class="field-label">Body / Description<span class="required-asterisk">*</span></div>
          <mat-form-field>
            <textarea matInput formControlName="body" rows="3" placeholder='e.g., "Get best prices for Hyderabad → Cochin"'></textarea>
          </mat-form-field>
        </div>
      </div>

      <div class="row mtb">
        <div class="col-md-6">
          <div class="field-label">CTA Button Text<span class="required-asterisk">*</span></div>
          <mat-form-field>
            <input matInput formControlName="cta_text" placeholder='e.g., "Book Now"' />
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <div class="field-label">Deep Link (Web/Mobile)<span class="required-asterisk">*</span></div>
          <mat-form-field>
            <input matInput formControlName="deep_link" placeholder='e.g., "app://booking/offers"' />
          </mat-form-field>
        </div>
      </div>

      <!-- Image Upload Section -->
      <div class="row mtb mb-4">
        <div class="col-md-12">
          <div class="field-label mb-2">Banner Image (Optional)</div>
          <div class="banner-upload-box" (click)="uploadImage.click()">
            <div *ngIf="!uploadedImageUrl && !imageLoading" class="upload-placeholder">
              <p>📷 Click to browse and upload a banner image</p>
              <p style="font-size: 12px; color: #aaa;">Recommended size: 800 x 400px (JPG, PNG)</p>
            </div>
            <div *ngIf="imageLoading" class="upload-placeholder">
              <p>Uploading Image...</p>
            </div>
            <div *ngIf="uploadedImageUrl && !imageLoading" class="uploaded-img-container">
              <img [src]="uploadedImageUrl" class="bannerImg" />
              <div class="change-overlay">
                <span>Click to change image</span>
              </div>
            </div>
            <input #uploadImage type="file" (change)="onFileChange($event)" hidden accept="image/*" />
          </div>
          <div *ngIf="uploadedImageUrl && !imageLoading" class="text-right mt-2">
            <a href="javascript:void(0)" (click)="removeImage()" style="color: red; font-size: 14px; text-decoration: underline;">Remove Image</a>
          </div>
        </div>
      </div>

    </div>

    <div class="pull-left w-100 mt-2 mb-3" style="text-align: right;">
      <button
        type="button"
        class="button buttonBlue"
        [disabled]="imageLoading || !notificationForm.valid"
        [ngClass]="{ 'button-disabled': imageLoading || !notificationForm.valid }"
        (click)="saveNotification()"
      >
        Save
      </button>
    </div>
  </div>
</div>
